import { get, postMultiPart, getImageStream, deleteRequest } from "../../../shared/data";
import { DATE_FNS_LONG_DATE_FORMAT } from "../../../shared/constants";
import { format } from "date-fns";

export const getAttachments = (shipmentKey) => {
    // **** Expected To Return Array Of:
    // {
    //     filename: 'blah.txt',
    //     date: '1234568'
    // }
    return get(`/receiving/shipments/${shipmentKey}/attachments`).then((attachments) => {
        return attachments.map((attachment) => {
            return {
                filename: attachment.friendlyFilename,
                notes: attachment.notes,
                date: format(new Date(attachment.createdOn), DATE_FNS_LONG_DATE_FORMAT),
                number: attachment.number,
            };
        });
    });
};

// **** Expected Payload
// {
//   "files": array,
//   "notes": "string",
//   "name": "string",
// }
export const addAttachment = (shipmentKey, payload) => {
    return postMultiPart(`/receiving/shipments/${shipmentKey}/attachments`, payload);
};

export const deleteAttachment = (shipmentKey, number) => {
    return deleteRequest(`/receiving/shipments/${shipmentKey}/attachments/${number}`);
};

export const streamImageAttachment = (shipmentKey, number) => {
    const url = `/receiving/shipments/${shipmentKey}/attachments/${number}/stream`;

    return getImageStream(url);
};
